let cursor

import carousel from './carousel'
import { matchesOrContained } from './helpers'

const interactiveSelector = 'a, button, input, select, .nice-select'

export default {
  init: () => {
    if (matchMedia('(pointer: fine)').matches) {
      cursor = document.createElement('div')
      cursor.id = 'cursor'

      document.body.appendChild(cursor)
      document.documentElement.classList.add('js-custom-cursor')

      window.addEventListener('mousemove', mouseMoveHandler)
      window.addEventListener('mousedown', mouseDownHandler)
      window.addEventListener('mouseup', mouseUpHandler)
      window.addEventListener('mouseover', linkEnterHandler)
      window.addEventListener('mouseout', linkLeaveHandler)

      carousel.instances.forEach(instance => {
        instance.on('dragMove', mouseMoveHandler)
      })
    }
  },
}

function mouseMoveHandler({ clientX, clientY }) {
  cursor.style.opacity = 1
  cursor.style.transform = `translate(${clientX - cursor.offsetWidth / 2}px, ${
    clientY - cursor.offsetHeight / 2
  }px)`
}

function mouseUpHandler() {
  cursor.classList.remove('active')
}

function mouseDownHandler() {
  cursor.classList.add('active')
}

function linkEnterHandler(event) {
  if (matchesOrContained(interactiveSelector, event.target)) {
    cursor.classList.add('hover')
  }
}

function linkLeaveHandler(event) {
  if (matchesOrContained(interactiveSelector, event.target)) {
    cursor.classList.remove('hover')
  }
}
